// extracted by mini-css-extract-plugin
export default {"container":"ploVx5","shrinked":"ttsU9H","icon":"TpMw4i","title":"U5K2tH mz-default-dark-font","message":"E2iTRx mz-default-dark-font","button":"Yy1qzi","buttonsContainer":"PsdFrZ"};